import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';

import { DashboardState } from 'src/redux/dashboard/reducers';
import { pullRequest as pullRequestSchema } from 'src/redux/pull-request/schemas';
import {
  getDashboard,
  getEntities,
} from 'src/selectors/state-slicing-selectors';

import { DashboardPullRequestsState } from '../reducers/pull-requests';

export const getPullRequestsSlice = createSelector(
  getDashboard,
  (dashboard: DashboardState) => dashboard.pullRequests
);

const getPullRequests = createSelector(
  getPullRequestsSlice,
  (slice: DashboardPullRequestsState) => slice.pullRequests
);

const getAuthorPullRequestKeys = createSelector(
  getPullRequests,
  pullRequests => pullRequests.authored
);

const getReviewingPullRequestsKeys = createSelector(
  getPullRequests,
  pullRequests => pullRequests.reviewing
);

const getClosedPullRequestKeys = createSelector(
  getPullRequests,
  pullRequests => pullRequests.closed
);

export const getReviewingPullRequests = createSelector(
  getReviewingPullRequestsKeys,
  getEntities,
  (keys, entities) => denormalize(keys, [pullRequestSchema], entities)
);

export const getAuthoredPullRequests = createSelector(
  getAuthorPullRequestKeys,
  getEntities,
  (keys, entities) => denormalize(keys, [pullRequestSchema], entities)
);

export const getClosedPullRequests = createSelector(
  getClosedPullRequestKeys,
  getEntities,
  (keys, entities) => denormalize(keys, [pullRequestSchema], entities)
);

export const getPullRequestsFilters = createSelector(
  getPullRequestsSlice,
  (slice: DashboardPullRequestsState) => slice.pullRequestFilters
);
